/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Open_SettingsInputs */

const en_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Live Captioning settings`)
};

const fr_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir les paramètres de sous-titrage en direct`)
};

const de_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen für Live-Untertitelung öffnen`)
};

const it_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri le impostazioni dei sottotitoli in tempo reale`)
};

const ru_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть настройки субтитров в реальном времени`)
};

const es_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir la configuración de subtítulos en directo`)
};

const zh_cn2_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开实时字幕设置`)
};

const ja_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプション設定を開く`)
};

const hi_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग सेटिंग्स खोलें`)
};

const pt_pt2_live_caption_open_settings = /** @type {(inputs: Live_Caption_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra as configurações de Legendas ao Vivo.`)
};

/**
* | output |
* | --- |
* | "Open Live Captioning settings" |
*
* @param {Live_Caption_Open_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_open_settings = /** @type {((inputs?: Live_Caption_Open_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Open_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_open_settings(inputs)
	if (locale === "de") return de_live_caption_open_settings(inputs)
	if (locale === "it") return it_live_caption_open_settings(inputs)
	if (locale === "ru") return ru_live_caption_open_settings(inputs)
	if (locale === "es") return es_live_caption_open_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_open_settings(inputs)
	if (locale === "ja") return ja_live_caption_open_settings(inputs)
	if (locale === "hi") return hi_live_caption_open_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_open_settings(inputs)
	return en_live_caption_open_settings(inputs)
});